<div class="footer">
    <div class="footer-header">
        <div class="footer-logo">
            <img src="assets/images/logo.svg" alt="Logo">
        </div>
        <div class="footer-social">
            <a href="">
                <img src="../../assets/images/facebook.svg" alt="Facebook">
            </a>
            <a href="">
                <img src="../../assets/images/instagram.svg" alt="Instagram">
            </a>
            <a href="">
                <img src="../../assets/images/x.svg" alt="X">
            </a>
            <a href="">
                <img src="../../assets/images/linkedin.svg" alt="Linkedin">
            </a>
        </div>
    </div>
    <div class="footer-content">
        <div class="footer-info">
            <p class="footer-title">Compañía</p>
            <a href="/quienes-somos">
                <p class="footer-text">Acerca de nosotros</p>
            </a>
            <a href="/terms-conditions">
                <p class="footer-text">Téminos y condiciones de uso</p>
            </a>
            <a href="/privacy">
                <p class="footer-text">Política de tratamiento de datos personales</p>
            </a>
        </div>
        <div class="footer-info">
            <p class="footer-title">Descarga nuestra aplicación</p>
            <div class="footer-get-app">
                <a href="https://play.google.com/store/apps/details?id=co.workbi&pcampaignid=web_share" target="_blank"
                    rel="noopener noreferrer">
                    <img src="assets/images/google-play.svg" width="160" alt="Disponible en Google Play">
                </a>
                <a href="https://apps.apple.com/co/app/workbi/id6756087985?l=en-GB" target="_blank"
                    rel="noopener noreferrer">
                    <img src="assets/images/download-ios.svg" width="160" alt="Consíguelo en el App Store">
                </a>
            </div>
        </div>
    </div>
</div>